var paragraph_default = {
  "fontElementMap": "toDZE",
  "elementSpacing": "G-wmm",
  "text": "IXtWz G-wmm",
  "child": "_5eFT4"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
